import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../utils/config-service';
import { Quota } from '../../models/quota';
import { CalculateQuotaRequest, CalculateQuotaResponse } from '../../models/calculateQuota';

import { Observable } from 'rxjs/Rx';
import { TotalUserQuota } from '../../models/TotalUserQuota';
import { QuotaDetail } from '../../models/quotaDetails';
import { QuotaHistory } from '../../models/quotaHistory';

@Injectable()
export class QuotaApiService {
  private quotaUrl: string;
  private jsonHeader: HttpHeaders;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.quotaUrl = this.configService.getEnv('quotaApi');
    this.jsonHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  getOwnQuota(): Observable<QuotaDetail> {
    let url = `${this.quotaUrl}details`;

    return this.http.get(url)
      .map((result: any) => {
        let json = result;
        if (json) {
          return new QuotaDetail(json);
        }
      })
      .catch((error: any) => {
        throw error;
      }) as any;
  }

  getQuotaHistory(companyId: string, userId: string, from: string, to: string): Observable<QuotaHistory[]> {
    let url = `${this.quotaUrl}history/${from}/${to}?userId=${userId}`;

    if (companyId) {
      url = url + `&companyId=${companyId}`;
    }

    return this.http.get(url)
      .map((result: any) => {
        let json = result;
        if (json) {
          return json.map(i => new QuotaHistory(i));
        }
      })
      .catch((error: any) => {
        throw error;
      });
  }

  getQuotaForCompanies(): Observable<{} | QuotaDetail> {
    let url = `${this.quotaUrl}company`;

    return this.http.get(url)
      .map((result: any) => {
        let json = result;
        if (json) {
          return json.map(qJson => new Quota(qJson));
        }
      })
      .catch((error: any) => {
        throw error;
      });
  }

  getAllQuotasForCompany(companyId: string): Observable<{} | QuotaDetail> {
    let url = `${this.quotaUrl}details?userId=${companyId}`;

    return this.http.get(url)
      .map((result: any) => {
        let json = result;
        if (json) {
          return new QuotaDetail(json);
        }
      })
      .catch((error: any) => {
        throw error;
      });
  }

  setQuotaForCompany(companyId: string, update: { quota?: number; apiKey?: string }): Observable<{} | boolean> {
    let url = `${this.quotaUrl}company/${companyId}`;

    return this.http.put(url, JSON.stringify({ limit: update.quota, apiKey: update.apiKey }), { headers: this.jsonHeader })
      .map(() => {
        return true;
      })
      .catch((error: any) => {
        throw error;
      });
  }

  getQuotaForCompanyUsers(companyId: string): Observable<{} | Quota[]> {
    let url = `${this.quotaUrl}company/${companyId}/users`;

    return this.http.get(url)
      .map((result: any) => {
        let json = result;
        if (json) {
          return json.map(qJson => new Quota(qJson));
        }
      })
      .catch((error: any) => {
        throw error;
      });
  }

  setQuotaForUser(companyId: string, userId: string, quotaLimit: number): Observable<{} | boolean> {
    let url = `${this.quotaUrl}company/${companyId}/users/${userId}`;

    return this.http.put(url, JSON.stringify({ limit: quotaLimit }), { headers: this.jsonHeader })
      .map((result: any) => {
        return true;
      })
      .catch((error: any) => {
        throw error;
      });
}

  calculateQuota(request: CalculateQuotaRequest): Observable<CalculateQuotaResponse> {
    let url = `${this.quotaUrl}calculate`;
    return this.http.post(url, JSON.stringify(request), { headers: this.jsonHeader })
      .map((result: any) => {
        return new CalculateQuotaResponse(result);
      }).catch((error: any) => {
        throw error;
      }) as any;
  }

  getTotalQuota(): Observable<{} | TotalUserQuota> {
    let url = `${this.quotaUrl}details`;
    return this.http.get(url)
      .map((result: any) => {
        return new TotalUserQuota(result);
      })
      .catch((error: any) => {
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/quota/quota.api.service.ts